import React, { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip'; 
import { BotonEditar } from '../../Utils/BotonEditar';
import { useAuth } from '../../../Auth/AuthContext';

export default function Ayudasxentidades(){
    const {token, user} = useAuth();
    const [cargando, setCargando] = useState(false);
    const [AyudasxEntidades, setAyudasxEntidades] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    const [entidades, setEntidades] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => (<BotonEditar Editar={Editar} row={row}></BotonEditar>),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Ayuda', selector: row => row.ayu_ayuda, sortable: true, width:'40%' },
        { name: 'Entidad', selector: row => row.entidad, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.ayu_activo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        IniciarFormularioAyudasEntidades();
        fetchData();
    }, []);
    const fetchData = async () => {
        let url = `/parametros/listarayudasentidades`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data.ayudasporentidad;
        setAyudasxEntidades(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function IniciarFormularioAyudasEntidades() {
        setCargando(true);
        let url = `/parametros/iniciarformularioayudasentidades`;
        apiService.get(url, token)
        .then((response) => {
            setAyudas(response.data.ayudas);
            setEntidades(response.data.entidades);
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
        })
        .finally(() => {
            setCargando(false);
        });
    }

    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('usrid', user);
        setValue('ayu_ayudaid', row.ayu_ayudaid);
        setValue('ayu_identidad', row.ayu_identidad);
        setValue('ayu_activo', row.ayu_activo);
    };
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('usrid', user);
        setValue('ayu_ayudaid', '');
        setValue('ayu_identidad', '');
        setValue('ayu_activo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarayudasentidad';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar ayuda por entidad', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar ayuda por entidad', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar ayuda por entidad', JSON.stringify(error.response.data.message));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('usrid', user);
        setValue('ayu_ayudaid', '');
        setValue('ayu_identidad', '');
        setValue('ayu_activo', false);
        setMuestraFormulario(false);
    }
    
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Ayudas por entidades</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/caracterizacion/administrarcaracterizacion`} >Administrar</NavLink></li>
                        <li className="breadcrumb-item active"> Ayudas por entidades</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario</h3>
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('usrid')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='ayu_ayudaid'>Ayuda</label>
                                                <select
                                                    id='ayu_ayudaid'
                                                    {...register('ayu_ayudaid', { required: true })}
                                                    className="form-control"
                                                >
                                                    <option value="">Seleccione una ayuda</option>
                                                    {ayudas.map((ayuda) => (
                                                        <option key={ayuda.id} value={ayuda.id}>
                                                            {ayuda.ayuda}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.ayu_ayudaid && <p style={{color: 'red'}}>Seleccione una ayuda</p>}
                                            </div>  
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <label htmlFor='ayu_identidad'>Entidad</label>
                                                <select
                                                    id='ayu_identidad'
                                                    {...register('ayu_identidad', { required: true })}
                                                    className="form-control"
                                                >
                                                    <option value="">Seleccione una entidad</option>
                                                    {entidades.map((entidad) => (
                                                        <option key={entidad.id} value={entidad.id}>
                                                            {entidad.entidad}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.ayu_identidad && <p style={{color: 'red'}}>Seleccione una entidad</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('ayu_activo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <button className='form-control' onClick={Nuevo}>Nuevo</button>
                                <DataTable
                                    title="Ayudas por entidades"
                                    columns={columns}
                                    data={AyudasxEntidades}
                                    progressPending={cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}